module.exports = __webpack_public_path__ + "img/london_feature.abd6ff44.jpg";